// Form continuation validation
// Checks if form error messages are present to determine if user
// can proceed.
// ----------------------------------------------------------------

import $ from 'jquery';

export function validationContinue(fieldset) {

    var formContinueCheck = fieldset.find('.js-formErrorMessage');

    if ($(formContinueCheck).hasClass('js-errorMessageVisible')) {
        return false;
    } else {
        return true;
    }

}
